import { assign } from '@xstate/immer';
import { findOptionIndex } from './actions.js';

/**
 * **Not Compatible with Multi-select**
 *
 * Provides an `onActiveChanged` action which overrides the default placeholder
 * function. When the active option changes the new active option is set as the
 * only selected option.
 *
 */
function setActiveAsOnlySelected(ctx) {
    var activeOption = ctx.activeOption;
    if (activeOption) {
        ctx.options[findOptionIndex(ctx, activeOption.value)].selected = true;
        ctx.options.forEach(function (option) {
            option.selected = option.value === activeOption.value;
        });
    }
}
var actions = {
    onActiveChanged: assign(function (ctx) {
        setActiveAsOnlySelected(ctx);
    }),
};

export { actions };
//# sourceMappingURL=actionsSelectActive.js.map
